import React, { useEffect, useRef } from "react";
import StaticAlertBanner from "./StaticAlertBanner";
import { MessageType } from "../../constants/Messages";

interface AlertBannerProps {
    title?: string; // Optional title for the alert
    message: string; // The message to display
    message_type: MessageType; // Alert type
    onClose: () => void; // Callback for closing the alert
    className?: string; // Optional custom className
    isHtml?: boolean; // If true, interpret `message` as HTML
}

const AlertBanner: React.FC<AlertBannerProps> = ({
                                                     title,
                                                     message,
                                                     message_type,
                                                     onClose,
                                                     className,
                                                     isHtml = false,
                                                 }) => {
    const alertRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (alertRef.current) {
            alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }

        const timer = setTimeout(onClose, 10000); // Auto-close after 10 seconds
        return () => clearTimeout(timer);
    }, [ message, onClose ]);

    return (
        <div ref={alertRef}>
            <StaticAlertBanner
                title={title}
                message={message}
                message_type={message_type}
                onClose={onClose}
                className={className}
                isHtml={isHtml}
            />
        </div>
    );
};

export default AlertBanner;
